import { Link } from "react-router-dom";
import { Hotel, Facebook, Instagram, Twitter, Youtube, Linkedin } from "lucide-react";
import "./hp-theme.css";

const NAVY = "#14304F";
const DESTS = ["Kochi", "Munnar", "Alappuzha", "Wayanad", "Kovalam", "Varkala", "Thekkady", "Kumarakom"];

const Col = ({ title, children }) => (
  <div>
    <div className="text-xs font-700 uppercase tracking-widest text-stone-400 mb-3">{title}</div>
    <div className="space-y-2">{children}</div>
  </div>
);
const F = ({ to, children }) => (
  <Link to={to} className="block text-sm text-stone-300 hover:text-white transition-colors">{children}</Link>
);

/** HotelsPulse.pro branded footer — shown on every HotelsPulse page. */
export const HPFooter = () => (
  <footer data-testid="hp-footer" className="text-white" style={{ background: NAVY }}>
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-12 grid sm:grid-cols-2 lg:grid-cols-5 gap-8">
      <div className="lg:col-span-2">
        <div className="flex items-center gap-2">
          <span className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center"><Hotel className="w-4 h-4" /></span>
          <span className="hp-display font-bold text-lg">HotelsPulse<span className="text-teal-300">.pro</span><sup className="text-[9px] text-stone-400">™</sup></span>
        </div>
        <p className="text-sm text-stone-300 mt-3 max-w-xs">Distinctive stays, direct connections. Independent hotels keep the guest relationship — we never add a booking commission.</p>
        <div className="flex gap-2 mt-4">
          {[Facebook, Instagram, Twitter, Youtube, Linkedin].map((Icon, i) => (
            <span key={i} className="w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center cursor-pointer transition-colors"><Icon className="w-3.5 h-3.5" /></span>
          ))}
        </div>
      </div>
      <Col title="Destinations">
        {DESTS.map((d) => <F key={d} to={`/hotelspulse/stays?q=${d}`}>{d}</F>)}
      </Col>
      <Col title="For Hotels">
        <F to="/hotelspulse/dashboard">List your property</F>
        <F to="/hotelspulse/dashboard">Partner dashboard</F>
        <F to="/hotelspulse#plans">Plans & pricing</F>
        <F to="/hotelspulse#how-it-works">How it works</F>
        <F to="/hotelspulse#page-styles">Page styles</F>
      </Col>
      <Col title="Network">
        <F to="/">TravelerPulse.pro</F>
        <F to="/guardian">Travel Guardian</F>
        <F to="/hotelspulse/stays">Browse all stays</F>
        <span className="block text-sm text-stone-500">KeralaTravels — coming soon</span>
      </Col>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-4 flex flex-wrap items-center justify-between gap-2 text-xs text-stone-400">
        <span>© 2026 HotelsPulse.pro · Part of the SocialPulse family</span>
        <span>Verified information · Direct hotel response · No commission on your stay</span>
      </div>
    </div>
  </footer>
);
